import { Suspense, lazy, useEffect } from 'react';
import { ThemeProvider } from '@emotion/react';
import { Global } from '@emotion/react';
import { Navigate, useRoutes } from 'react-router-dom';
import theme, { globalStyle } from './theme';
import { navRoutes } from './constants';
import * as T from './components/Typography';
import RouteWrapper from './components/RouteWrapper';

const PreForm = lazy(() => import('./pages/PreForm'));
const FirstForm = lazy(() => import('./pages/FirstForm'));
const SecondForm = lazy(() => import('./pages/SecondForm'));

import {
  createTheme,
  ThemeOptions,
  ThemeProvider as MuiThemeProvider
} from '@mui/material/styles';
import InitializeGoogleAnalytics from './utils/googleAnalytics';
import { refreshCSRFToken } from './utils/csrf-token-manager';

const muiTheme = createTheme(theme as unknown as ThemeOptions);

const AppRoutes = () =>
  useRoutes([
    {
      path: navRoutes.GENERAL.HOME,
      element: (
        <RouteWrapper layout="general">
          <PreForm />
        </RouteWrapper>
      )
    },
    {
      path: navRoutes.FORM.PRE_FORM,
      element: (
        <RouteWrapper layout="general">
          <PreForm />
        </RouteWrapper>
      )
    },
    {
      path: navRoutes.FORM.FIRST_FORM,
      element: (
        <RouteWrapper layout="general">
          <FirstForm />
        </RouteWrapper>
      )
    },
    {
      path: navRoutes.FORM.SECOND_FORM,
      element: (
        <RouteWrapper layout="general">
          <SecondForm />
        </RouteWrapper>
      )
    },
    {
      path: navRoutes.GENERAL.NOT_FOUND,
      element: (
        <RouteWrapper layout="general">
          <T.H1 color="white">
            Sorry we can&apos;t find what you&apos;re looking for
          </T.H1>
        </RouteWrapper>
      )
    },
    // FALLBACK ROUTE
    {
      path: '*',
      element: <Navigate to={navRoutes.GENERAL.NOT_FOUND} />
    }
  ]);

function App() {
  useEffect(() => {
    InitializeGoogleAnalytics();
    refreshCSRFToken();
  }, []);

  return (
    <div className="App">
      <Global styles={globalStyle} />
      <ThemeProvider theme={theme}>
        <MuiThemeProvider theme={muiTheme}>
          <Suspense fallback={null}>
            <AppRoutes />
          </Suspense>
        </MuiThemeProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
